import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FieldIcon from "../../../utils/Register/field_icon";
import SendBtn from "../../../utils/Register/send_btn";
import conversion from "../../../assets/wito.png";
import backImage from "../../../assets/fondo.png";
import { FaLock } from "react-icons/fa";

const RecoverPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || ""; // correo desde la pantalla anterior

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden");
      return;
    }

    try {
      const response = await fetch(
        "https://server-postgre.vercel.app/api/password/update-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al cambiar contraseña");
      }

      navigate("/signin");
    } catch (error) {
      setError("Error: " + error.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div
        className="flex flex-col items-center bg-cover bg-center rounded-xl"
        style={{
          backgroundImage: `url(${backImage})`,
          maxWidth: "420px",
          padding: "0 5%",
          backgroundClip: "padding-box",
        }}
      >
        <div className="text-center text-white mb-8 mt-12">
          <div className="flex justify-center mt-2">
            <img src={conversion} alt="Conversión" className="h-8" />
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-lg w-96">
          <h2 className="text-2xl font-bold text-center mb-6">
            Restablece tu contraseña
          </h2>
          <form onSubmit={handleSubmit}>
            <FieldIcon
              type="password"
              placeholder="Introduce tu nueva contraseña"
              icon={<FaLock />}
              label="Contraseña"
              id="password"
              name="password"
              autoComplete="new-password"
              value={password}
              required
              onChange={(e) => setPassword(e.target.value)}
            />

            <FieldIcon
              type="password"
              placeholder="Ingresa de nuevo tu contraseña"
              icon={<FaLock />}
              label="Confirmar Contraseña"
              id="confirmPassword"
              name="confirmPassword"
              autoComplete="new-password"
              value={confirmPassword}
              required
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            <SendBtn
              label="Recuperar"
              type="submit"
              style={{ backgroundColor: "#E5960E" }}
            />
            {error && <p className="text-red-500 text-center mt-2">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default RecoverPassword;
